module.exports = __webpack_public_path__ + "static/media/bolso (30).d744f36c.jpg";